module.exports = __webpack_public_path__ + "static/1-7beaf04d514a3888398f38df0c87284f.jpg";